import React from 'react';
import { View, Text, StyleSheet, Animated, Pressable } from 'react-native';
import Colors from '../../constants/Colors';

const theme = Colors.light;
const { spacing, radius } = Colors;

export const ScoreCard = ({ title, score, date, type = 'gain', style }) => {
    const scaleValue = React.useRef(new Animated.Value(1)).current;

    const onPressIn = () => {
        Animated.spring(scaleValue, { toValue: 0.97, useNativeDriver: true, friction: 8 }).start();
    };
    const onPressOut = () => {
        Animated.spring(scaleValue, { toValue: 1, useNativeDriver: true, friction: 5 }).start();
    };

    const isGain = type === 'gain';
    const accentColor = isGain ? theme.scoreGain : theme.scoreLoss;
    const icon = isGain ? '+' : '';

    return (
        <Pressable onPressIn={onPressIn} onPressOut={onPressOut}>
            <Animated.View style={[
                styles.card,
                { transform: [{ scale: scaleValue }] },
                style
            ]}>
                <View style={styles.content}>
                    <View style={styles.textBlock}>
                        <Text style={styles.title} numberOfLines={2}>{title}</Text>
                        <Text style={styles.date}>{date}</Text>
                    </View>
                    <View style={[styles.scoreBadge, { backgroundColor: isGain ? theme.scoreGainBg : theme.scoreLossBg }]}>
                        <Text style={[styles.scoreText, { color: accentColor }]}>{icon}{score}</Text>
                    </View>
                </View>
            </Animated.View>
        </Pressable>
    );
};

const styles = StyleSheet.create({
    card: {
        backgroundColor: theme.card,
        borderRadius: radius.card,
        paddingVertical: spacing.md,
        paddingHorizontal: spacing.lg,
        marginVertical: 3,
        ...theme.shadowCard,
    },
    content: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: spacing.sm,
    },
    textBlock: {
        flex: 1,
    },
    title: {
        fontSize: 15,
        fontWeight: '500',
        color: theme.text,
        lineHeight: 20,
        letterSpacing: -0.2,
    },
    date: {
        fontSize: 12,
        color: theme.textSecondary,
        marginTop: 3,
        letterSpacing: -0.1,
    },
    scoreBadge: {
        paddingVertical: 6,
        paddingHorizontal: 12,
        borderRadius: radius.sm,
        minWidth: 46,
        alignItems: 'center',
    },
    scoreText: {
        fontWeight: '700',
        fontSize: 16,
        letterSpacing: -0.3,
    }
});
